<template>
  <div v-if="!!phaseData">
    <div v-for="mdaOption in mdaOptions" :key="mdaOption.key">
      <radio-options
        :options="mdaOption.options || defaultMdaOptions"
        v-model="phaseData.answers[mdaOption.key]"
        class="mb-2"
        :label="mdaOption.name"
        row
        clearable
        :change="calculateMda()"
      />
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import BasePhase from '@/components/AttendanceForm/general/phase/BasePhase.vue'
import { MDA_OPTIONS } from '@/components/AttendanceForm/espondiloartrites/constants/mda.js'
import RadioOptions from '@/components/RadioOptions.vue'

export default {
  extends: BasePhase,
  components: { RadioOptions },
  data() {
    return {
      mdaOptions: MDA_OPTIONS,
    }
  },
  computed: {
    defaultMdaOptions() {
      return [
        { text: 'Sim', value: true },
        { text: 'Não', value: false },
      ]
    },
  },
  methods: {
    getDefaultData() {
      const phaseData = {
        answers: {},
      }
      this.mdaOptions.forEach((item) => {
        phaseData.answers[item.key] = null
      })
      phaseData['mda'] = null
      return phaseData
    },
    getSubtitle(showSub) {
      if (!showSub) {
        return null
      }
      return 'Essa opção já foi preenchida em Anamnese - Sintomas'
    },
    calculateMda() {
      const sum = Object.values(this.phaseData.answers).reduce((total, value) => {
        return value ? total + 1 : total
      })

      let isNull = true
      Object.values(this.phaseData.answers).forEach((item) => {
        if (item !== null) {
          isNull = false
        }
      })
      this.phaseData.mda = isNull ? null : sum >= 5 ? true : false
    },
  },
}
</script>
